import styled from '@emotion/styled'

import {cssTheme} from '@vio/atlas/themes'

export const OffersWrapper = styled.div`
  padding: 0 ${cssTheme.layout.spacing.s400};
  box-shadow: 0 0 0 1px ${cssTheme.colors.border.neutral.secondary};
  border-radius: ${cssTheme.layout.radius.lg};
  overflow: hidden;
  &.--full-width {
    width: 100%;
  }
`

export const Legend = styled.div`
  margin-top: ${cssTheme.layout.spacing.s300};
`

export const LegendWrapper = styled.div`
  display: grid;
  grid-column-gap: ${cssTheme.layout.spacing.s200};
  grid-auto-flow: column;
  margin-left: ${cssTheme.layout.spacing.s500};
`

const LegendBox = styled.div`
  height: ${cssTheme.layout.spacing.s500};
  width: ${cssTheme.layout.spacing.s500};
  border-radius: ${cssTheme.layout.radius.sm};
`

export const LegendBoxGreen = styled(LegendBox)`
  background-color: ${cssTheme.colors.background.success.secondary};
`

export const LegendBoxRed = styled(LegendBox)`
  background-color: ${cssTheme.colors.background.danger.tertiary};
  margin-left: ${cssTheme.layout.spacing.s300};
`
